import { getBizChatWindowKey } from "../utils/getBizChatWindowKey";
import { isTasksHubActive } from "../selectors/isTasksHubActive";
import { setTasksHubActiveMutator } from "../mutators/setTasksHubActiveMutator";

/**
 * Deactivates the Tasks Hub for the given window when it is active.
 * Returns whether the active drawer view changed.
 */
export function ensureCopilotChatDrawerIsInChatView(targetWindow: Window): boolean {
    const windowKey = getBizChatWindowKey(targetWindow);
    if (!isTasksHubActive(windowKey)) {
        return false;
    }
    
    setTasksHubActiveMutator(windowKey, false);
    return true;
}
